import { api } from '@/api/api'
import { rotasApi } from '@/configurações/rotasApi'
import { useQuery } from '@tanstack/react-query'

export const usePrivacidadeGet = () => {
  const { data } = useQuery({
    queryKey: ['privacidade'],
    queryFn: async () => await endPoint(),
  })

  return { data }
}

async function endPoint(): Promise<string> {
  const result = await api().get(rotasApi.privacidadeBuscar)
  return result.data.data
}
